import React, { memo } from 'react';
import css from './CountWords.less';
interface IProps {
  count?;
  allCount?;
}
const CountWords = (props: IProps) => {
  const { count, allCount } = props;

  return (
    <span className={css.countWords}>
      {count}/{allCount}
    </span>
  );
};
export default memo(CountWords);
